import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { ImageDialogComponent } from './image-dialog.component';

@NgModule({
  declarations: [
    ImageDialogComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    SharedModule
  ],
  exports: [
    ImageDialogComponent
  ],
  entryComponents: [
    ImageDialogComponent
  ]
})
export class ImageDialogModule { }
